
import { ScrollTrigger } from 'gsap/ScrollTrigger';


function lazyLoadVideos (){
	// To use this the video src should be empty and the data-src attribute should have the video url.
	const videos = document.querySelectorAll('[data-name="video-lazy-load"]');

	if ( videos.length > 0 ) {
		videos.forEach(video => {
			const source   = video.querySelector('source')
			const videoUrl = source.getAttribute('data-src')

			video.addEventListener('canplay', () => {
				video.play();
				ScrollTrigger.refresh();
			});

			// Set source when video is near viewport
			const observer = new IntersectionObserver((entries) => {
				if (entries[0].isIntersecting) {
					source.setAttribute('src', videoUrl);
					video.load();
					observer.disconnect();
				}
			});
			
			observer.observe(video);
		});
	}
}

function video(){
	lazyLoadVideos();
}

export { video };
